import { ImageScaleView, ImageView, View } from '@play-co/timestep-core/ui';
import bitmapFonts from 'src/lib/bitmapFonts';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { CatalogItem } from 'src/replicant/catalog/catalog.ruleset';
import LazyImageCoverView from 'src/lib/ui/components/LazyImageCoverView';
import { assertNever } from 'src/replicant/utils';
import { getDecorationPath } from '../decoration/helpers';
import TierView from './TierView';
import ButtonScaleView, {
  ButtonScaleViewOpts,
} from 'src/lib/ui/components/ButtonScaleView';
import { getAccessoryPath } from '../accessories/helpers';

/**
 * Create catalog item view
 */
export default class CatalogItemView {
  private size = {
    width: 156,
    height: 195,
  };
  private view: ImageScaleView;
  private image: LazyImageCoverView;
  private tier: TierView;
  private quantity: LangBitmapFontTextView;
  private quantityLabel: ImageView;

  /**
   * Create view
   */
  constructor(opts: ButtonScaleViewOpts) {
    this.view = new ButtonScaleView({
      image: 'assets/ui/catalog/frames/cell.png',
      ...opts,
      ...this.size,
    });

    const width = this.view.style.width;

    this.image = new LazyImageCoverView({
      superview: this.view,
      mode: 'contain',
      verticalAlign: 'center',
      horizontalAlign: 'center',
      x: (width - 130) * 0.5,
      y: 15,
      width: 130,
      height: 130,
      spinnerColor: '#CCCCCC',
    });

    this.quantityLabel = new ImageView({
      superview: this.view,
      image: 'assets/ui/catalog/icons/item_quantity.png',
      width: 42,
      height: 39,
      x: width - 42,
    });

    this.quantity = new LangBitmapFontTextView({
      superview: this.quantityLabel,
      x: -2,
      y: -2,
      width: 42,
      height: 40,
      align: 'center',
      verticalAlign: 'center',
      size: 20,
      localeText: () => '',
      font: bitmapFonts('Body'),
    });

    this.tier = new TierView({
      superview: this.view,
      x: 0,
      y: 145,
      width,
      height: 38,
      star: {
        width: 27,
        height: 27,
      },
    });
  }

  /**
   * Set item data
   */
  public setItem(item: CatalogItem) {
    this.tier.setTier(item.tier, item.maxTier);

    const type = item.type;
    switch (type) {
      case 'decoration':
        void this.image.updateImage(getDecorationPath(item.image)!);
        break;
      case 'accessory':
        void this.image.updateImage(getAccessoryPath(item.image, item.tierId));
        break;
      default:
        assertNever(type);
    }

    if (item.quantity > 1) {
      this.quantity.localeText = () => `${item.quantity}`;
      this.quantityLabel.show();
    } else {
      this.quantityLabel.hide();
    }
  }

  /**
   * Get view
   */
  public getView(): View {
    return this.view;
  }
}
